/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConfirmUpdatePlan,
    ConfirmUpdatePlanFromJSON,
    ConfirmUpdatePlanFromJSONTyped,
    ConfirmUpdatePlanToJSON,
} from './ConfirmUpdatePlan';

/**
 * 
 * @export
 * @interface ConfirmUpdatePlanResponse
 */
export interface ConfirmUpdatePlanResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof ConfirmUpdatePlanResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof ConfirmUpdatePlanResponse
     */
    message: string;
    /**
     * 
     * @type {ConfirmUpdatePlan}
     * @memberof ConfirmUpdatePlanResponse
     */
    data: ConfirmUpdatePlan;
}

export function ConfirmUpdatePlanResponseFromJSON(json: any): ConfirmUpdatePlanResponse {
    return ConfirmUpdatePlanResponseFromJSONTyped(json, false);
}

export function ConfirmUpdatePlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmUpdatePlanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ConfirmUpdatePlanFromJSON(json['data']),
    };
}

export function ConfirmUpdatePlanResponseToJSON(value?: ConfirmUpdatePlanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ConfirmUpdatePlanToJSON(value.data),
    };
}

